/**
 * @generated SignedSource<<4876dcf5ff78ba535847179bf89f7e49>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CompanyLink_company",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
        }
    ],
    "type": "Company",
    "abstractKey": null
};
node.hash = "473f86a9a5cf02c85ec8ad43106509bd";
export default node;
